<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
      <CCard>
        <CCardHeader>
          <h4>Καταχώρηση Εξωτερικού Τιμολογίου B2G</h4>
          <small class="text-muted">Τιμολόγιο που έχει ήδη δημιουργηθεί στο myDATA</small>
        </CCardHeader>

        <CModal
          :show.sync="alertIsShown"
          :centered="true"
          size="lg"
        >
          <CAlert
            closeButton
            :show.sync="alertIsShown"
            :color="alertColor"
            fade
          >
            {{ message }}
          </CAlert>
        </CModal>

        <CCardBody class="p-4">
          <div class="form-container">
          <!-- Document Information -->
          <h5 class="mb-3">Στοιχεία Παραστατικού</h5>
          <CRow class="mb-3">
            <CCol xl="6" lg="12">
              <label class="requiredLabel">Τύπος παραστατικού</label>
              <multiselect
                v-model="document_series"
                :options="document_series_options"
                label="label"
                track-by="value"
                @input="changeSeiraOptions"
                :allow-empty="false"
              />
            </CCol>
            <CCol xl="6" lg="12">
              <label class="requiredLabel">Σειρά</label>
              <multiselect
                v-model="document_series_seira"
                :options="document_series_seira_options"
                label="label"
                track-by="value"
              />
            </CCol>
          </CRow>

          <CRow class="mb-3">
            <CCol xl="6" lg="12">
              <label class="requiredLabel">Ημερομηνία Έκδοσης</label>
              <CInput type="date" v-model="invoice_date" />
            </CCol>
            <CCol xl="6" lg="12">
              <label class="requiredLabel">Γλώσσα</label>
              <multiselect
                v-model="invoice_lang"
                :options="invoice_lang_options"
                label="label"
                track-by="value"
              />
            </CCol>
          </CRow>

          <hr class="my-4">

          <!-- Municipality/Client -->
          <h5 class="mb-3">Στοιχεία Δήμου/Φορέα</h5>
          <CRow class="mb-3">
            <CCol xl="12" lg="12">
              <label class="requiredLabel">Δήμος/Φορέας (Μόνο Δημόσιοι Φορείς)</label>
              <multiselect
                v-model="client"
                :options="government_clients_options"
                label="label"
                track-by="value"
                @input="selectedClient"
                placeholder="Επιλέξτε Δήμο ή Φορέα"
              />
              <small class="text-muted">Εμφανίζονται μόνο πελάτες που είναι δημόσιοι φορείς</small>
            </CCol>
          </CRow>

          <hr class="my-4">

          <!-- AADE Details -->
          <h5 class="mb-3">Στοιχεία από myDATA (AADE)</h5>
          <CRow class="mb-3 align-items-start">
            <CCol xl="3" lg="12">
              <div style="margin-bottom: 8px;">
                <label class="requiredLabel mb-0">Αριθμός Παραστατικού</label>
              </div>
              <CInput
                v-model="document_number"
                placeholder="Αριθμός από AADE"
              />
              <small class="text-muted d-block mt-1">Από το myDATA</small>
            </CCol>
            <CCol xl="3" lg="12">
              <div style="margin-bottom: 8px;">
                <label class="requiredLabel mb-0">MARK</label>
              </div>
              <CInput
                v-model="mark"
                placeholder="π.χ. 400012345678901"
              />
              <small class="text-muted d-block mt-1">Μοναδικός αριθμός MARK</small>
            </CCol>
            <CCol xl="3" lg="12">
              <div style="margin-bottom: 8px;">
                <label class="mb-0">
                  UID
                  <CIcon
                    name="cil-info"
                    v-c-tooltip="{content: 'Unique Identifier που επιστρέφει το myDATA μαζί με το MARK. Είναι προαιρετικό πεδίο.'}"
                    class="text-info ml-1"
                    style="cursor: help; vertical-align: baseline;"
                  />
                </label>
              </div>
              <CInput
                v-model="uid"
                placeholder="π.χ. ABC123XYZ456"
              />
              <small class="text-muted d-block mt-1">Προαιρετικό</small>
            </CCol>
            <CCol xl="3" lg="12">
              <div style="margin-bottom: 8px;">
                <label class="mb-0">QR URL</label>
              </div>
              <CInput
                v-model="qr_url"
                placeholder="https://..."
              />
              <small class="text-muted d-block mt-1">&nbsp;</small>
            </CCol>
          </CRow>

          <hr class="my-4">

          <!-- B2G Specific Fields -->
          <h5 class="mb-3">Πληροφορίες B2G</h5>
          <CRow class="mb-3">
            <CCol xl="4" lg="12">
              <label>CPV Code</label>
              <CInput
                v-model="cpv_code"
                placeholder="π.χ. 71356200-5"
              />
              <small class="text-muted">Common Procurement Vocabulary για δημόσιες προμήθειες</small>
            </CCol>
            <CCol xl="4" lg="12">
              <label>Αριθμός Σύμβασης</label>
              <CInput
                v-model="government_contract_ref"
                placeholder="Αριθμός σύμβασης με το δήμο"
              />
            </CCol>
            <CCol xl="4" lg="12">
              <label>Diavgeia ΑΔΑ</label>
              <CInput
                v-model="diavgeia_ref"
                placeholder="π.χ. ΨΧΩΦ46ΨΖΞ0-ΑΚΕ"
              />
            </CCol>
          </CRow>

          <CRow class="mb-3">
            <CCol xl="6" lg="12">
              <label>Αριθμός Πρωτοκόλλου Δήμου</label>
              <CInput
                v-model="protocol_number"
                placeholder="Αριθμός πρωτοκόλλου"
              />
            </CCol>
            <CCol xl="6" lg="12">
              <label>Ημερομηνία Πρωτοκόλλου</label>
              <CInput type="date" v-model="protocol_date" />
            </CCol>
          </CRow>

          <hr class="my-4">

          <!-- Line Items -->
          <h5 class="mb-3">Υποθέσεις (Cases)</h5>
          <CCard>
            <CCardBody class="p-3">
              <CRow class="mb-3">
                <CCol xl="12" lg="12">
                  <label class="requiredLabel">Υπόθεση</label>
                  <multiselect
                    v-model="selected_case"
                    :options="client_cases_options"
                    label="label"
                    track-by="value"
                    @input="selectedCase"
                    placeholder="Επιλέξτε υπόθεση του πελάτη"
                    :disabled="!client"
                  />
                  <small class="text-muted">Επιλέξτε πρώτα τον πελάτη για να φορτώσουν οι υποθέσεις του</small>
                </CCol>
              </CRow>

              <CRow class="mb-3">
                <CCol xl="12" lg="12">
                  <label class="requiredLabel">Περιγραφή</label>
                  <CTextarea
                    v-model="service_description"
                    rows="2"
                    placeholder="Περιγραφή υπηρεσίας"
                  />
                </CCol>
              </CRow>

              <CRow class="mb-3">
                <CCol xl="4" lg="12">
                  <label class="requiredLabel">Ποσότητα</label>
                  <CInput type="number" v-model="quantity" min="1" />
                </CCol>
                <CCol xl="4" lg="12">
                  <label class="requiredLabel">Τιμή χωρίς ΦΠΑ (€)</label>
                  <CInput type="number" v-model="price_without_vat" step="0.01" />
                </CCol>
                <CCol xl="4" lg="12">
                  <label>Συνολική Αξία (€)</label>
                  <CInput type="number" v-model="total_price" step="0.01" readonly />
                </CCol>
              </CRow>

              <CRow class="mt-3">
                <CCol>
                  <CButton
                    color="primary"
                    @click="addLineItem"
                    :disabled="!canAddLineItem"
                  >
                    Προσθήκη Γραμμής
                  </CButton>
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>

          <!-- Line Items Table -->
          <CDataTable
            v-if="line_items.length > 0"
            :items="line_items"
            :fields="line_items_fields"
            class="mt-3"
            hover
          >
            <template #actions="{item, index}">
              <td>
                <CButton
                  color="danger"
                  size="sm"
                  @click="removeLineItem(index)"
                >
                  Διαγραφή
                </CButton>
              </td>
            </template>
          </CDataTable>

          <hr class="my-4">

          <!-- Payment Tracking -->
          <h5 class="mb-3">Πληρωμές</h5>
          <CRow class="mb-3">
            <CCol xl="4" lg="12">
              <label>Κατάσταση Πληρωμής</label>
              <multiselect
                v-model="payment_status"
                :options="payment_options"
                label="label"
                track-by="value"
              />
            </CCol>
            <CCol xl="4" lg="12">
              <label>Ποσό που Πληρώθηκε (€)</label>
              <CInput type="number" v-model="paid_amount" step="0.01" />
            </CCol>
            <CCol xl="4" lg="12">
              <label>Σχόλια Πληρωμής</label>
              <CInput v-model="payment_comment" />
            </CCol>
          </CRow>

          <!-- Summary -->
          <CCard class="mt-4 bg-light">
            <CCardBody>
              <h5>Σύνοψη</h5>
              <p><strong>Σύνολο χωρίς ΦΠΑ:</strong> {{ totalWithoutVAT.toFixed(2) }}€</p>
              <p><strong>ΦΠΑ (24%):</strong> {{ totalVAT.toFixed(2) }}€</p>
              <p><strong>Γενικό Σύνολο:</strong> {{ grandTotal.toFixed(2) }}€</p>
            </CCardBody>
          </CCard>

          <!-- Submit Button -->
          <CRow class="mt-4">
            <CCol>
              <CButton
                color="success"
                size="lg"
                @click="submitInvoice"
                :disabled="!canSubmit || submitting"
                class="mr-2"
              >
                {{ submitting ? 'Καταχώρηση...' : 'Καταχώρηση Τιμολογίου' }}
              </CButton>
              <CButton
                color="secondary"
                size="lg"
                @click="$router.push('/invoices')"
              >
                Ακύρωση
              </CButton>
            </CCol>
          </CRow>
          </div>

        </CCardBody>
      </CCard>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'

export default {
  name: 'AddExternalB2GInvoice',
  components: {
    Multiselect,
  },
  data() {
    return {
      // Document fields
      document_series: null,
      document_series_options: [],
      document_series_seira: null,
      document_series_seira_options: [],
      document_number: '',
      invoice_date: moment(new Date()).format('YYYY-MM-DD'),
      invoice_lang: { label: 'Ελληνικά', value: 'greek' },
      invoice_lang_options: [
        { label: 'Ελληνικά', value: 'greek' },
        { label: 'Αγγλικά', value: 'english' }
      ],

      // Client
      client: null,
      government_clients_options: [],

      // AADE fields
      mark: '',
      uid: '',
      qr_url: '',

      // B2G fields
      government_contract_ref: '',
      diavgeia_ref: '',
      protocol_number: '',
      protocol_date: null,

      // VAT - Fixed at 24% for B2G invoices
      vat_price: { value: 0.24, label: 'ΦΠΑ 24%' },
      vat_prices_options: [],

      // Line items
      selected_case: null,
      client_cases_options: [],
      cpv_code: '',
      service_description: '',
      quantity: 1,
      price_without_vat: 0,
      total_price: 0,
      line_items: [],
      line_items_fields: [
        { key: 'case_code', label: 'Κωδικός Υπόθεσης' },
        { key: 'service_name', label: 'Υπηρεσία' },
        { key: 'description', label: 'Περιγραφή' },
        { key: 'quantity', label: 'Ποσότητα' },
        { key: 'price_without_vat', label: 'Τιμή (€)' },
        { key: 'actions', label: '' }
      ],

      // Payment
      payment_status: null,
      payment_options: [],
      paid_amount: 0,
      payment_comment: '',

      // UI state
      message: '',
      alertIsShown: false,
      alertColor: 'success',
      submitting: false,
    }
  },
  computed: {
    canAddLineItem() {
      return this.selected_case &&
             this.service_description &&
             this.quantity > 0 &&
             this.price_without_vat > 0
    },
    canSubmit() {
      return this.document_series &&
             this.document_series_seira &&
             this.document_number &&
             this.invoice_date &&
             this.client &&
             this.mark &&
             this.line_items.length > 0
    },
    totalWithoutVAT() {
      return this.line_items.reduce((sum, item) => {
        return sum + (parseFloat(item.price_without_vat) * parseFloat(item.quantity))
      }, 0)
    },
    totalVAT() {
      return this.totalWithoutVAT * (this.vat_price ? this.vat_price.value : 0)
    },
    grandTotal() {
      return this.totalWithoutVAT + this.totalVAT
    }
  },
  watch: {
    price_without_vat(val) {
      this.calculateTotalPrice()
    },
    quantity(val) {
      this.calculateTotalPrice()
    },
    vat_price(val) {
      this.calculateTotalPrice()
    }
  },
  methods: {
    calculateTotalPrice() {
      const subtotal = parseFloat(this.price_without_vat || 0) * parseFloat(this.quantity || 1)
      const vatAmount = subtotal * (this.vat_price ? this.vat_price.value : 0)
      this.total_price = (subtotal + vatAmount).toFixed(2)
    },
    changeSeiraOptions() {
      if (this.document_series) {
        let seires = this.document_series.seires.filter(item => item.lang === 'gr')

        // For B2G invoices with ΤΠΥ, only show series "Δ"
        if (this.document_series.label.includes('Τιμολόγιο Παροχής Υπηρεσιών') ||
            this.document_series.label.includes('ΤΠΥ')) {
          seires = seires.filter(item => item.name === 'Δ' || item.name.toUpperCase() === 'Δ')
        }

        this.document_series_seira_options = seires.map(item => ({
          value: item.id,
          label: item.name,
          invoice_count: item.invoice_count
        }))

        if (this.document_series_seira_options.length > 0) {
          this.document_series_seira = this.document_series_seira_options[0]
        }
      }
    },
    async selectedClient(client) {
      if (!client) {
        this.client_cases_options = []
        return
      }

      // Load cases for selected client
      try {
        const response = await axios.get(
          `/api/clients/${client.value}?token=${localStorage.getItem('api_token')}`
        )

        // response.data is the client object directly (not nested)
        const clientData = response.data

        if (!clientData.cases || clientData.cases.length === 0) {
          this.client_cases_options = []
          this.message = 'Ο πελάτης δεν έχει υποθέσεις'
          this.alertColor = 'warning'
          this.alertIsShown = true
          return
        }

        this.client_cases_options = clientData.cases
          .filter(c => c.bill_status_id !== 3) // Exclude fully billed cases
          .map(c => ({
            value: c.id,
            label: `${c.case_code} - ${c.service?.name || 'N/A'}`,
            case_code: c.case_code,
            service_name: c.service?.name || 'N/A',
            service_id: c.service_id
          }))
      } catch (error) {
        console.error('Error loading client cases:', error)
        this.message = 'Σφάλμα κατά τη φόρτωση των υποθέσεων'
        this.alertColor = 'danger'
        this.alertIsShown = true
        this.client_cases_options = []
      }
    },
    selectedCase(caseObj) {
      if (caseObj) {
        // Auto-fill service description from case
        this.service_description = `${caseObj.case_code} - ${caseObj.service_name}`
      }
    },
    addLineItem() {
      if (!this.canAddLineItem) return

      this.line_items.push({
        case_id: this.selected_case.value,
        case_code: this.selected_case.case_code,
        service_name: this.selected_case.service_name,
        description: this.service_description,
        quantity: this.quantity,
        price_without_vat: parseFloat(this.price_without_vat)
      })

      // Reset form
      this.selected_case = null
      this.service_description = ''
      this.quantity = 1
      this.price_without_vat = 0
      this.total_price = 0
    },
    removeLineItem(index) {
      this.line_items.splice(index, 1)
    },
    async submitInvoice() {
      if (!this.canSubmit) return

      this.submitting = true

      try {
        const payload = {
          // Document info
          document_series_id: this.document_series.value,
          document_series_seira_id: this.document_series_seira.value,
          document_number: this.document_number,
          invoice_date: this.invoice_date,
          invoice_language: this.invoice_lang.value,

          // Client
          client_id: this.client.value,

          // AADE details
          mark: this.mark,
          uid: this.uid,
          qr_url: this.qr_url || null,
          date_mark_created: this.invoice_date,

          // B2G fields
          cpv_code: this.cpv_code || null,
          government_contract_ref: this.government_contract_ref || null,
          diavgeia_ref: this.diavgeia_ref || null,
          protocol_number: this.protocol_number || null,
          protocol_date: this.protocol_date || null,

          // VAT
          fpa_percentage: this.vat_price.value,

          // Line items
          line_items: this.line_items.map(item => ({
            case_id: item.case_id,
            service_description: item.description,
            quantity: item.quantity,
            price_without_vat: item.price_without_vat
          })),

          // Payment
          paid_amount: parseFloat(this.paid_amount) || 0,
          payment_status: this.payment_status ? this.payment_status.value : null,
          payment_comment: this.payment_comment || null
        }

        const response = await axios.post(
          '/api/invoices/external-b2g?token=' + localStorage.getItem('api_token'),
          payload
        )

        this.message = 'Το τιμολόγιο B2G καταχωρήθηκε επιτυχώς!'
        this.alertColor = 'success'
        this.alertIsShown = true

        setTimeout(() => {
          this.$router.push(`/invoices/${response.data.invoice_id}`)
        }, 1500)

      } catch (error) {
        console.error('Error submitting invoice:', error)
        this.message = error.response?.data?.message || 'Σφάλμα κατά την καταχώρηση'

        if (error.response?.data?.errors) {
          this.message += '\n' + Object.values(error.response.data.errors).flat().join('\n')
        }

        this.alertColor = 'danger'
        this.alertIsShown = true
      } finally {
        this.submitting = false
      }
    },
    async loadFormData() {
      try {
        const response = await axios.get(
          '/api/invoices/create?token=' + localStorage.getItem('api_token')
        )

        // Document series
        this.document_series_options = response.data.document_series
          .filter(item => !item.greek_name.includes('Ακυρωτικό'))
          .map(item => ({
            value: item.id,
            label: item.greek_name,
            seires: item.seires
          }))

        // Find default B2G series or first available
        this.document_series = this.document_series_options.find(
          item => item.label.includes('Τιμολόγιο')
        ) || this.document_series_options[0]

        if (this.document_series) {
          this.changeSeiraOptions()
        }

        // Filter only government clients
        this.government_clients_options = response.data.clients
          .filter(client => client.is_government)
          .map(client => ({
            value: client.id,
            label: client.company
          }))

        // VAT rates - Always use 24% for B2G
        this.vat_prices_options = response.data.vat_prices.map(vat => ({
          value: vat.percentage,
          label: vat.vat
        }))
        // Force 24% VAT for B2G invoices
        this.vat_price = this.vat_prices_options.find(v => v.value === 0.24) || { value: 0.24, label: 'ΦΠΑ 24%' }

        // Payment options
        this.payment_options = response.data.payment_options.map((label, index) => ({
          value: index,
          label: label
        }))
        this.payment_status = this.payment_options[0]

      } catch (error) {
        console.error('Error loading form data:', error)
        if (error.response?.status === 401) {
          this.$router.push('/login')
        }
      }
    }
  },
  mounted() {
    this.loadFormData()
  }
}
</script>

<style scoped>
.requiredLabel::after {
  content: ' *';
  color: red;
}
</style>

<style>
/* Override CoreUI card-body height issues */
.card-body {
  height: auto !important;
  min-height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.card {
  height: auto !important;
  min-height: auto !important;
}

/* Form container to control layout */
.form-container {
  height: auto !important;
  display: block !important;
}

/* Remove any flex-related height issues */
.card-body > .row {
  height: auto !important;
}

.card-body .row {
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: 0 !important;
}
</style>
